/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useState} from "react";

import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";

import ApplicationApiContext from "@Contexts/Api";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";
import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";

import {TERMINAL_INTERFACE} from "@Services/Application/Interfaces/Terminals/Terminal";

import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


import {Col, Row} from "react-bootstrap";

import {AiFillDelete, AiFillSave, MdCancel} from "react-icons/all";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";


type FavouriteTerminalsElementProps = {
    TERMINAL_DATA: TERMINAL_INTERFACE | null;
    TERMINALS_LIST_HANDLER(eventType: string, terminalId?: string | null): void;
};


export const FavouriteTerminalsElementComponent: React.FC<FavouriteTerminalsElementProps> = ({
    TERMINAL_DATA = null,
    TERMINALS_LIST_HANDLER = null
}): JSX.Element | null => {


    /** @const Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    /** @const {UserInterface | null} Application Logged User (from Global Store Object) */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;

    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [removeFromFavoritesStatus, setRemoveFromFavoritesStatus] = useState<boolean>(false);
    const [removeFromFavoritesMessage, setRemoveFromFavoritesMessage] = useState<string | null>(null);

    const changeRemoveFromFavoritesStatus = (status: boolean): void => {
        setRemoveFromFavoritesMessage(null);
        setRemoveFromFavoritesStatus(status);
    }

    const changeRemoveFromFavoritesMessage = (message: string | null): void => {
        setRemoveFromFavoritesStatus(false);
        setRemoveFromFavoritesMessage(message);
    }

    useEffect(() => {
        return () => {
            setRemoveFromFavoritesStatus(false);
            setRemoveFromFavoritesMessage(null);
        };
    }, []);


    if (!TERMINAL_DATA || !TERMINALS_LIST_HANDLER) return null;


    const {
        TerminalNo: terminalId,
        TerminalName: terminalName
    } = TERMINAL_DATA;


    const removeFromFavoritesRequestHandler = async () => {

        /** @const REMOVE_TERMINAL_API_URL Terminals List REST API Endpoint URL */
        const REMOVE_TERMINAL_API_URL: string = REST_API_URL + "/Terminal/Favorite";

        /** @const REMOVE_TERMINAL_REQUEST_DATA Terminals List Request Data Object */
        const REMOVE_TERMINAL_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID, // Logged User ID
            TerminalNo: terminalId // Data Return Mode - Simplified
        };

        try {

            const REMOVE_TERMINAL_RESPONSE = await REST_API_REQUEST(
                REMOVE_TERMINAL_API_URL,
                REMOVE_TERMINAL_REQUEST_DATA,
                REST_API_REQUEST_TOKEN,
                "DELETE"
            );

            if (REMOVE_TERMINAL_RESPONSE.status === 204) {
                TERMINALS_LIST_HANDLER("remove", terminalId);
            } else {
                if (REMOVE_TERMINAL_RESPONSE.status === 409) {
                    const ERROR: HTTP_ERROR_RESPONSE_INTERFACE = await REMOVE_TERMINAL_RESPONSE.json();
                    changeRemoveFromFavoritesMessage(ERROR.UserMessage);
                } else {
                    changeRemoveFromFavoritesMessage("Wystąpił nieokreślony błąd");
                }
            }

        } catch (e) {
            TERMINALS_LIST_HANDLER("error");
        }

    }


    return (
        <Col xs={12} lg={4} className={"favorite-terminals-element favorite-terminals-element-component"}>
            <Row className={"favorite-terminals-element-content"}>

                <Col xs={8} className={"terminal-name"}>
                    <span>{terminalName}</span>
                </Col>

                <Col xs={4} className={"terminal-remove"}>
                    {/*{!!removeFromFavoritesStatus &&*/}
                    {/*<a href={`#remove-terminal-${terminalId}`} title={"Potwierdź usunięcie"} className={"terminal-remove-submit-handler"} onClick={() => removeFromFavoritesRequestHandler()}>*/}
                    {/*    <AiFillSave />*/}
                    {/*</a>*/}
                    {/*}*/}
                    <a href={`#remove-terminal-${terminalId}`} title={"Usuń z ulubionych"} className={"terminal-remove-change-status" + (removeFromFavoritesStatus ? " active" : "")} onClick={() => removeFromFavoritesRequestHandler()}>
                        {removeFromFavoritesStatus ? <MdCancel /> : <AiFillDelete />}
                    </a>
                </Col>

                {/*{!!removeFromFavoritesStatus &&*/}
	            {/*<Col xs={12} className={"terminal-remove-message"}>*/}
		        {/*    <span>{`Potwierdź usunięcie Stacji Paliw z Listy Ulubionych`}</span>*/}
	            {/*</Col>*/}
                {/*}*/}

                {!!removeFromFavoritesMessage &&
                <Col xs={12} className={"terminal-remove-message"}>
                    <span>{removeFromFavoritesMessage}</span>
                </Col>
                }

            </Row>
        </Col>
    );

};


export default FavouriteTerminalsElementComponent;
